import { inject, Service } from "@angular/core";

import { AgmMilestone, AgmTask, MainResponseModel } from "../models";
import { MainService } from "./main-service";

@Service()
export class AgmMilestoneApiService {
  private _mainService = inject(MainService);

  public getMilestone(id: number) {
    return this._mainService.sendRequest<MainResponseModel<AgmMilestone>>({
      method: "GET",
      url: `annual-meeting-project-milestone/getById/${id}`,
    });
  }

  public updateMilestone(isFinish: boolean = true, data: AgmMilestone) {
    return this._mainService.sendRequest<MainResponseModel>({
      method: "PUT",
      url: `annual-meeting-project-milestone/update?isFinish=${isFinish}`,
      data: data,
    });
  }

  public getMilestonesByProjectId(id: number) {
    return this._mainService.sendRequest<MainResponseModel<AgmMilestone[]>>({
      method: "GET",
      url: `annual-meeting-project-milestone/getMilestoneValuesByProjectId/${id}`,
    });
  }

  public getTasks(milestoneId: number) {
    return this._mainService.sendRequest<MainResponseModel<AgmTask[]>>({
      method: "GET",
      url: `annual-meeting-project-milestone/getTasks?milestoneId=${milestoneId}`,
    });
  }
}
